import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { H1, Loading } from "@components";
import { useFetchProject } from "features/projects/hooks/useFetchProject";
import { Project } from "features/projects/components/Project";
import { DeleteProjectButton } from "features/projects/components/DeleteProjectButton";
import { CheckProjectButton } from "features/projects/components/CheckProjectButton";
import { useBreadcrumbs } from "@hooks/useBreadcrumbs/useBreadcrumbs";
import type { IProjectId } from "features/projects/types";
import type { IWorkspaceId } from "features/workspaces/types";

import { useEffect } from "react";

export const ProjectPage = () => {
  const { workspaceId, projectId } = useParams() as unknown as { workspaceId: IWorkspaceId; projectId: IProjectId };
  const [project, isLoading] = useFetchProject({ projectId });

  const { setBreadcrumbsMap } = useBreadcrumbs();

  useEffect(() => {
    if (!project) {
      return;
    }

    setBreadcrumbsMap({
      workspaceId: project.workspace.name,
      projectId: project.name,
    });
  }, [project]);

  if (isLoading) {
    return <Loading />;
  }

  if (!project) {
    return <H1 label="Project not found" />;
  }

  return (
    <>
      <H1 label={`Project: ${project.name}`}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <DeleteProjectButton id={project.id} />
          <CheckProjectButton id={project.id} />
        </Box>
      </H1>

      <Project workspaceId={workspaceId} project={project} />
    </>
  );
};
